module.exports = __webpack_public_path__ + "static/img/6.1a70145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/6.png
// module id = Jsky
// module chunks = 12